import React, { PropsWithChildren } from "react";
import Skeleton from "react-loading-skeleton";

type WithSkeletonProps = {
  isLoading: boolean;
  width?: number;
  height?: number;
};

const WithSkeleton: React.FC<WithSkeletonProps & PropsWithChildren> = ({
  isLoading,
  children,
  width,
  height,
}) => {
  if (isLoading) return <Skeleton width={width} height={height} />;

  return <>{children}</>;
};

export default WithSkeleton;
